<ng-container #innerContainer></ng-container>
<div class="arrow" #arrow></div>
